(() => {
  const hostSelector = 'shopify-forms-embed';
  const formId = 'obp-withdrawal-form';

  const setLabel = (root, selector, text) => {
    const element = root.querySelector(selector);
    if (element && element.textContent.trim() !== text) element.textContent = text;
  };

  const requireField = (root, selector, autocomplete) => {
    const field = root.querySelector(selector);
    if (!field) return;
    field.required = true;
    field.setAttribute('required', '');
    field.setAttribute('aria-required', 'true');
    if (autocomplete) field.setAttribute('autocomplete', autocomplete);
  };

  const replaceValidationText = (root) => {
    root.querySelectorAll('*').forEach((element) => {
      if (element.children.length === 0 && element.textContent.trim() === 'Vorname ist erforderlich') {
        element.textContent = 'Vollständiger Name ist erforderlich';
      }
    });
  };

  const patchForm = (host) => {
    const root = host.shadowRoot;
    if (!root) return false;

    host.id = formId;
    host.setAttribute('aria-label', 'Vertrag widerrufen');
    const dialog = root.querySelector('[role="dialog"]');
    if (dialog) dialog.setAttribute('aria-label', 'Vertrag widerrufen');
    const submitButton = root.querySelector('button[type="submit"]');
    if (!submitButton) return true;

    setLabel(root, 'h1, h2, h3, [role="heading"]', 'Vertrag widerrufen');
    setLabel(root, 'button[type="submit"]', 'Widerruf bestätigen');
    setLabel(root, 'label[for="first_name"]', 'Vollständiger Name');
    setLabel(root, 'label[for="custom#bestellnummer"]', 'Bestellnummer oder Angaben zur Bestellung');
    replaceValidationText(root);
    root.querySelectorAll('p').forEach((paragraph) => {
      if (paragraph.textContent.trim() === 'Bitte geben Sie Ihre Bestellnummer bekannt.') {
        paragraph.textContent = 'Bitte geben Sie Ihre Bestellnummer oder andere Angaben an, mit denen wir den Vertrag eindeutig zuordnen können.';
      }
    });
    requireField(root, '#first_name', 'name');
    requireField(root, '#email', 'email');
    requireField(root, '[id="custom#bestellnummer"]', 'off');

    if (!root.__obpWithdrawalObserver) {
      const observer = new MutationObserver(() => patchForm(host));
      observer.observe(root, { childList: true, subtree: true });
      root.__obpWithdrawalObserver = observer;
    }

    return true;
  };

  const scan = () => {
    document.querySelectorAll(hostSelector).forEach((host) => patchForm(host));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  const pageObserver = new MutationObserver(scan);
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
